module.exports = __webpack_public_path__ + "img/juridocs.34da274c.png";